"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UIRadioInput = _interopRequireDefault(require("UIComponents/input/UIRadioInput"));

var DynoSchedulingOptions =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DynoSchedulingOptions, _PureComponent);

  function DynoSchedulingOptions() {
    (0, _classCallCheck2.default)(this, DynoSchedulingOptions);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DynoSchedulingOptions).apply(this, arguments));
  }

  (0, _createClass2.default)(DynoSchedulingOptions, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          formatedMessage = _this$props.formatedMessage,
          handleUpdate = _this$props.handleUpdate,
          value = _this$props.value,
          isPublished = _this$props.isPublished;
      return _react.default.createElement(_UIFormControl.default, {
        label: formatedMessage('scheduling')
      }, _react.default.createElement(_UIFlex.default, null, _react.default.createElement(_UIBox.default, {
        className: "m-right-6"
      }, _react.default.createElement(_UIRadioInput.default, {
        className: "dyno-scheduling-option__dont-schedule-option",
        name: "dontSchedule",
        onChange: function onChange() {
          return handleUpdate(false);
        },
        checked: value === false
      }, formatedMessage('dontSchedule'))), _react.default.createElement(_UIBox.default, null, _react.default.createElement(_UIRadioInput.default, {
        className: "dyno-scheduling-option__schedule-option",
        name: "schedule",
        onChange: function onChange() {
          return handleUpdate(true);
        },
        checked: value === true
      }, isPublished ? formatedMessage('scheduleForUnpublish') : formatedMessage('scheduleForLater')))));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        formatedMessage: _react.default.PropTypes.func.isRequired,
        handleUpdate: _react.default.PropTypes.func.isRequired,
        value: _react.default.PropTypes.bool.isRequired,
        isPublished: _react.default.PropTypes.bool.isRequired
      };
    }
  }]);
  return DynoSchedulingOptions;
}(_react.PureComponent);

exports.default = DynoSchedulingOptions;
module.exports = exports.default;